import { useProjectDelete } from '@/module/Author/Project';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface ProjectDeleteButtonProps {
  projectId: Id;
}

export function ProjectDeleteButton({ projectId }: ProjectDeleteButtonProps) {
  const mutation = useProjectDelete(projectId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      size="xs"
      {...deleteProps}
    />
  );
}
